import { cn } from '@/lib/utils';
import { formatNumber } from '../admin/format';

/**
 * When in the day people come: 24 cells, the busier the darker. Reads the
 * peak at a glance without an axis; the exact figure is on hover.
 */
export function HourStrip({
  hours,
  label = (h) => `${String(h).padStart(2, '0')}:00`,
  className,
  testId,
}: {
  /** 24 values, hour 0 first. */
  hours: number[];
  label?: (hour: number) => string;
  className?: string;
  testId?: string;
}) {
  const max = Math.max(0, ...hours);
  const peak = max > 0 ? hours.indexOf(max) : -1;
  return (
    <div className={cn('flex flex-col gap-2', className)} data-testid={testId}>
      <div className="grid grid-cols-12 gap-1 sm:grid-cols-24" dir="ltr">
        {hours.map((v, h) => {
          const share = max > 0 ? v / max : 0;
          return (
            <div
              key={h}
              title={`${label(h)} · ${formatNumber(v)}`}
              className={cn('h-8 rounded-[5px] bg-foreground', h === peak && 'ring-2 ring-foreground/30 ring-offset-1 ring-offset-background')}
              style={{ opacity: v > 0 ? 0.12 + share * 0.88 : 0.05 }}
            />
          );
        })}
      </div>
      <div className="flex justify-between text-[11px] tabular-nums text-muted-foreground" dir="ltr">
        <span>{label(0)}</span>
        <span>{label(6)}</span>
        <span>{label(12)}</span>
        <span>{label(18)}</span>
        <span>{label(23)}</span>
      </div>
    </div>
  );
}
